module.exports = __webpack_public_path__ + "static/media/subscribeForm.74c00fc1.png";